import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { PlanService } from '../plan.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { FirstLetterUpperCase } from '../../shared/pipe/firstletteruppercase.pipe';
import { LowerCasePipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import 'rxjs/add/observable/of';
import { TDUModel } from '../../shared/models/shared-models';

// global variable
declare var google;

@Component({
	selector: 'app-plan-detail',
	templateUrl: './plan-detail.component.html',
	providers: [LowerCasePipe]
})
export class PlanDetailComponent implements OnInit {
	// validation field required
	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);

	displayedColumns = ['AverageMonthlyUse', '500kWh', '1000kWh', '2000kWh'];
	public detailedView: DetailedView;
	public show_more_detail: boolean;
	public show_more: string;
	// public variable define
	public plan_rate: string;
	public plan_detail: any = [];
	public tdu: string;
	public service_address_obj: Object;
	public valid_enroll: boolean;
	public esiid: string;
	public zipcode: string;
	public is_exact_address: boolean;
	public error_message: string;
	public apt_units: any = [];
	public apt_unit: string;
	public apartment_list: any = [];
	public apartment_obs: Observable<string[]>;
	public is_loader: boolean;
	public duns_tdu: any;
	public duns: string;
	public old_key: number;
	public which_event: string;
	public places: any;
	public is_address_addlis: boolean;
	public search_val: any;
	public avgkwh500: string;
	public avgkwh1000: string;
	public avgkwh2000: string;
	public is_zipcode_diff: any;
	public tdus: TDUModel[];
	public service_address_search: any;

	private documents: any = {
		en: {
			EFL: '',
			TOS: '',
			PDS: '',
			YRAC: ''
		},
		es: {
			EFL: '',
			TOS: '',
			PDS: '',
			YRAC: ''
		}
	}
	constructor(private meta: Meta, private title: Title, private activatedRoute: ActivatedRoute, private router: Router,
		public dialog: MatDialog, private sharedService: SharedService,
		private planService: PlanService, private localStorageService: LocalStorageService,
		private firstLetterPipe: FirstLetterUpperCase, private lowerCasePipe: LowerCasePipe) {

		this.addUpdateMetaTags();

		this.fetchAllDocuments();

		if (this.localStorageService.get('token') != null) {
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(res => {
					if (res.status === 'success' && res.isTerminated === false) {
						this.router.navigate(['./dashboard']);
					} else {
						this.localStorageService.remove('token');
						this.localStorageService.remove('tempToken');
						this.router.navigate(['./sign-in']);
					}
				});
		}
		else {
			this.show_more_detail = false;
			this.show_more = 'More Details';
			this.sharedService.setHeaderTitle('plan_detail');
			this.valid_enroll = false;
			this.esiid = '';
			this.zipcode = '';
			this.is_loader = true;
			this.sharedService.setLoader('plan_detail', true);
			this.plan_rate = '0.0';
			this.is_exact_address = false;
			this.apt_unit = '';
			this.which_event = '';
			this.is_address_addlis = false;
			this.avgkwh500 = '0';
			this.avgkwh1000 = '0';
			this.avgkwh2000 = '0';
			this.is_zipcode_diff = false;
			this.service_address_search = '';

			this.sharedService.getElectricUtilityProviders().then(activeTdus => {
				this.tdus = activeTdus;
			});

			this.activatedRoute.params.subscribe((params: Params) => {
				if (params['esiid'] !== undefined) {
					this.esiid = params['esiid'];
					this.is_exact_address = true;
					this.valid_enroll = true;
				}
				if (params['zipcode'] !== undefined) {
					this.zipcode = params['zipcode'];
					this.is_exact_address = false;
					this.valid_enroll = false;
				}
				this.tdu = params['tdu'];
				this.localStorageService.set('tdu', params['tdu']);
				this.planService.getPlan({ 'esi_id': this.esiid, 'zipcode': this.zipcode, 'tdu': this.tdu })
					.then(plan_detail => {
						this.is_loader = false;
						const is_enroll = this.valid_enroll;
						setTimeout(function () {
							if (is_enroll) {
								if (document.getElementById('enroll_now') !== undefined) {
									document.getElementById('enroll_now').focus();
								}
							} else {
								// if (document.getElementById('service_address_id') !== undefined) {
								//     document.getElementById('service_address_id').focus();
								// }
							}
						}, 100);
						this.sharedService.setLoader('plan_detail', false);
						if (plan_detail.status === 'success') {
							if (plan_detail.result.length === 0) {
								this.router.navigate(['./service-not-available']);
							} else {
								this.plan_detail = plan_detail;
								this.plan_rate = plan_detail.result[0]['DisplayAvgPrice'];
								this.avgkwh500 = plan_detail.result[0]['kwh500'];
								this.avgkwh1000 = plan_detail.result[0]['kwh1000'];
								this.avgkwh2000 = plan_detail.result[0]['kwh2000'];
								this.detailedView = new DetailedView(plan_detail.result);
								//this.localStorageService.set('ProductID', plan_detail.result[0]['productId']);
								this.localStorageService.set('ProductID', 12);
								if (this.esiid !== '') {
									this.localStorageService.set('address_for_billing', this.plan_detail.ercotRecord[0]);
									this.service_address_obj = this.localStorageService.get('address_for_billing');

									var dataLayerEvent = 'enroll - step 0.5';
									(window as any).dataLayer.push(
										{
											'event': dataLayerEvent,
											'address1': this.service_address_obj['street_number'].toString() + " " + this.service_address_obj['street_address'].toString(),
											'address2': this.service_address_obj['apt_unit'].toString(),
											'city': this.service_address_obj['city'].toString(),
											'state': this.service_address_obj['state'].toString(),
											'zip': this.service_address_obj['zipcode'].toString(),
											'productID': 12,//plan_detail.result[0]['productID'].toString(),
											'ESIID': this.esiid.toString(),
											'TDU': this.tdu.toString()
										});
								} else {
									const thisObj = this;
									setTimeout(function () {
										const address = 'Texas';
										const geocoder = new google.maps.Geocoder();
										geocoder.geocode({ 'address': address }, function (results, status) {
											if (status === google.maps.GeocoderStatus.OK) {
												const latitude = [results[0].geometry.viewport.getSouthWest().lat(),
												results[0].geometry.viewport.getSouthWest().lng()];
												const longitude = [results[0].geometry.viewport.getNorthEast().lat(),
												results[0].geometry.viewport.getNorthEast().lng()];
												const stateBound = new google.maps.LatLngBounds(
													new google.maps.LatLng(latitude[0], latitude[1]),
													new google.maps.LatLng(longitude[0], longitude[1])
												);
												const options = {
													bounds: stateBound,
													strictBounds: true,
													types: ['geocode']
												}
												thisObj.places = new google.maps.places.Autocomplete(document.getElementById('service_address_id'), options);
											}
										});
									}, 10);
									setTimeout(function () {
										google.maps.event.addListener(thisObj.places, 'place_changed', function () {
											if (thisObj.places !== undefined) {
												const place = thisObj.places.getPlace();
												thisObj.getPlaces(place, thisObj, thisObj.search_val, 'place');
											}
										});
										thisObj.is_address_addlis = true;
									}, 500);
								}
							}
						} else {
							if (plan_detail.sgflag) {
								this.router.navigate(['./page-not-found']);
							} else {
								this.router.navigate(['./service-not-available']);
							}

						}
					});
			});
		}
	}

	addUpdateMetaTags() {
		this.title.setTitle('Plans | Pogo Energy');
		const titleTag = this.meta.getTag('name=title');

		if (titleTag != undefined) {
			this.meta.updateTag({ name: 'title', content: 'Plans | Pogo Energy' });
		} else {
			this.meta.addTag({ name: 'title', content: 'Plans | Pogo Energy' });
		}

		const descriptionTag = this.meta.getTag('name=description');

		if (descriptionTag != undefined) {
			this.meta.updateTag({ name: 'description', content: 'Choose no deposit electricity from Pogo Energy and you can save money and save the world. Save up to $300 a year with 100% clean energy. Same day power-on.' });
		} else {
			this.meta.addTag({ name: 'description', content: 'Choose no deposit electricity from Pogo Energy and you can save money and save the world. Save up to $300 a year with 100% clean energy. Same day power-on.' });
		}

		const title1Tag = this.meta.getTag('name=title1');

		if (title1Tag != undefined) {
			this.meta.updateTag({ name: 'title1', content: 'No Deposit' });
		} else {
			this.meta.addTag({ name: 'title1', content: 'No Deposit' });
		}

		const description1Tag = this.meta.getTag('name=description1');

		if (description1Tag != undefined) {
			this.meta.updateTag({ name: 'description1', content: 'No deposit electricity without the BS (bill shock). Save up to $300 a year with 100% clean energy. Cancel at any time without penalty.' });
		} else {
			this.meta.addTag({ name: 'description1', content: 'No deposit electricity without the BS (bill shock). Save up to $300 a year with 100% clean energy. Cancel at any time without penalty.' });
		}

		const title2Tag = this.meta.getTag('name=title2');

		if (title2Tag != undefined) {
			this.meta.updateTag({ name: 'title2', content: '100% Clean Energy ' });
		} else {
			this.meta.addTag({ name: 'title2', content: '100% Clean Energy ' });
		}

		const description2Tag = this.meta.getTag('name=description2');

		if (description2Tag != undefined) {
			this.meta.updateTag({ name: 'description2', content: '100% clean, renewable energy from sustainable sources like solar and wind. Get clean energy with no deposit electricity and save up to $300 a year.' });
		} else {
			this.meta.addTag({ name: 'description2', content: '100% clean, renewable energy from sustainable sources like solar and wind. Get clean energy with no deposit electricity and save up to $300 a year.' });
		}
	}

	ngOnDestroy() {
		this.title.setTitle('Pogo Energy');
		const titleTag = this.meta.getTag('name=title');

		if (titleTag != undefined) {
			this.meta.updateTag({ name: 'title', content: 'Pogo Energy' });
		}

		const descriptionTag = this.meta.getTag('name=description');

		if (descriptionTag != undefined) {
			this.meta.updateTag({ name: 'description', content: '' });
		}

		const title1Tag = this.meta.getTag('name=title1');
		if (title1Tag != undefined) {
			this.meta.removeTag('name=title1');
		}

		const title2Tag = this.meta.getTag('name=title2');
		if (title2Tag != undefined) {
			this.meta.removeTag('name=title2');
		}

		const description1Tag = this.meta.getTag('name=description1');
		if (description1Tag != undefined) {
			this.meta.removeTag('name=description1');
		}

		const description2Tag = this.meta.getTag('name=description2');
		if (description2Tag != undefined) {
			this.meta.removeTag('name=description2');
		}
	}

	fetchAllDocuments() {
		this.planService.getDocument('EFL', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['EFL'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('EFL', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['EFL'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('TOS', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['TOS'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('TOS', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['TOS'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('PDS', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['PDS'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('PDS', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['PDS'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('YRAC', 'English')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.en['YRAC'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});

		this.planService.getDocument('YRAC', 'Spanish')
			.then(res => {
				if (res != undefined && res.status == 'success') {
					this.documents.es['YRAC'] = res.result[0].document_url;
					// window.open(res.result[0].document_url, '_blank');
				}
			});
	}

	moreDetail() {
		if (this.show_more_detail === true) {
			this.show_more_detail = false;
		} else {
			this.show_more_detail = true;
		}
	}

	// view document of plan
	viewDocument(documentName: string) {
		let lang = document.getElementById('which_language').innerHTML;

		var urlObj;
		if (lang === 'English') {
			urlObj = this.documents.en;
		} else {
			urlObj = this.documents.es;
		}

		window.open(urlObj[documentName], '_blank');

		// let url = '';
		// if (lang === 'English') {
		//     lang = 'www';
		// }else {
		//     lang = 'es';
		// }

		// this.planService.getDocument(documentName,lang)
		//   .then(res=>{
		//     if (res != undefined && res.status == 'success') {
		//       window.open(res.result[0].document_url, '_blank');
		//     }
		//   });

		// this.planService.getDocumentUrls()
		//   .then(res=>{
		//     let url = '';
		//     var urlObj;
		//     if (lang === 'English') {
		//       urlObj = res.en;
		//     }else {
		//       urlObj = res.es;
		//     }

		//     if (documentName === 'EFL') {
		//       url = urlObj.efl;
		//     }else if (documentName === 'PDS') {
		//       url = urlObj.pds;
		//     }else if (documentName === 'TOS') {
		//       url = urlObj.tos;
		//     }else if (documentName === 'YRAC') {
		//       url = urlObj.yrac;
		//     }
		//     window.open(url, '_blank');
		//   });

		// this.planService.getDocument(documentName, lang);
		//  if (documentName === 'EFL') {
		//    url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2018/03/Pogo_Energy_EFL_20180226.pdf';
		//  }else if (documentName === 'PDS') {
		//    url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2018/03/Pogo_Energy_PDS_20180226.pdf';
		//  }else if (documentName === 'TOS') {
		//    url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2018/03/Pogo_Energy_TOS_20180226.pdf';
		//  }else if (documentName === 'YRAC') {
		//    url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2018/03/Pogo_Energy_YRAC_20180226.pdf';
		//  }
		// window.open(url, '_blank');
	}

	validEnroll(address_val: any) {
		if (address_val.target.value === '') {
			this.valid_enroll = false;
		} else {
			this.valid_enroll = true;
		}
	}

	// validate apt or unit
	validateApt() {
		if (document.getElementById('enroll_now') !== undefined) document.getElementById('enroll_now').setAttribute('disabled', '');
		//this.apt_unit = '';
	}

	ngOnInit() {
		const len = document.getElementsByTagName('body')[0];
		len.classList.add('body_autocomplete');
	}

	addClass() {
		setTimeout(function () {
			// tslint:disable-next-line:max-line-length
			const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-pane')[document.getElementsByClassName('cdk-overlay-pane').length - 1];
			if (!setPos.classList.contains('plan-apart-auto-cls')) {
				setPos.classList.add('plan-apart-auto-cls');
			}
			setPos.parentElement.classList.add('cdk-overlay-container-static');
		}, 10);

		setTimeout(function () {
			const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
			setcls.classList.add('nav-cls');
		}, 10);
	}

	removeClass() {
		const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
		setcls.classList.remove('nav-cls');
		const removeCls = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
		if (removeCls.classList.contains('cdk-overlay-container-static')) {
			removeCls.classList.remove('cdk-overlay-container-static');
		}

	}

	findApartUnit(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		if (search_val.target.value === '') {
			if (document.getElementById('is_error_address') !== undefined) document.getElementById('is_error_address').setAttribute('style', 'display:none');
			if (document.getElementById('is_error_address_yellow') !== undefined) document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
		}
		if (search_val.type === 'keyup' && (enter_key === 13) ||
			(this.old_key === 17 && enter_key === 86) || (this.old_key === 86 && enter_key === 17)) {
			document.getElementById('apartment').blur();
		}
		if (search_val.type === 'focusout') {
			if (search_val.target.value !== '') {
				this.chooseApartUnit(search_val.target.value, '');
			}
		}
		this.old_key = enter_key;
	}

	showRequire() {
		const len = document.getElementsByTagName('body')[0];
		len.click();
	}

	// getAddress method match address from ercot and validate it
	getAddress(search_val: any) {
		const enter_key = search_val.keyCode || search_val.which;
		const this_of_comp = this;
		this.which_event = '';
		this.search_val = search_val;
		if (!this.is_address_addlis) {
			google.maps.event.addListener(this_of_comp.places, 'place_changed', function () {
				if (this_of_comp.places !== undefined) {
					const place = this_of_comp.places.getPlace();
					this_of_comp.getPlaces(place, this_of_comp, this_of_comp.search_val, 'place');
				}
			});
			this.is_address_addlis = true;
		}
		if (search_val.target.value === '') {
			this.apt_unit = '';
			this.esiid = '';
			this.apartment_list = [];
			if (document.getElementById('is_error_address') !== undefined) document.getElementById('is_error_address').setAttribute('style', 'display:none');
			if (document.getElementById('is_error_address_yellow') !== undefined) document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			if (document.getElementById('is_apt_exist') !== undefined) document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			if (document.getElementById('enroll_now') !== undefined) document.getElementById('enroll_now').setAttribute('disabled', '');
		}

		if (search_val.type === 'keyup' && (enter_key === 13)) {
			document.getElementById('service_address_id').blur();
		}

		if (search_val.type === 'focusout') {
			this.apt_unit = '';
			this.apartment_list = [];
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			document.getElementById('enroll_now').setAttribute('disabled', '');
			document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
			if (search_val.target.value !== '') {
				document.getElementById('is_loader').setAttribute('style', '');
				const geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': search_val.target.value }, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						const place = results[0];
						this_of_comp.getPlaces(place, this_of_comp, search_val, 'geocode');
					} else {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('home_next').setAttribute('disabled', '');
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				});
			}
		}
		this.old_key = enter_key;
	}

	getPlaces(place: any, this_of_comp: any, search_val: any, which_event: any) {
		if (which_event !== 'place' || (which_event === 'place' && this_of_comp.which_event === 'ex_case')) {
			console.log(which_event);
			this_of_comp.which_event = '';
			let apt = '';
			let street_number = '';
			let street_address = '';
			let zipcode = '';
			let city = '';
			if (place !== undefined) {
				if (place['address_components'] !== undefined) {
					for (let i = 0; i < place['address_components'].length; i++) {
						if (place['address_components'][i]['types'][0] === 'postal_code') {
							zipcode = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'street_number') {
							street_number = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'locality') {
							city = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'subpremise') {
							apt = place['address_components'][i]['short_name'];
						}
						if (place['address_components'][i]['types'][0] === 'route') {
							street_address = place['address_components'][i]['short_name'];
						}
					}

					if (street_address !== '' && zipcode !== '' && this_of_comp.zipcode === zipcode) {
						if (!(which_event === 'geocode' && street_number.indexOf('-') > -1)) {
							this_of_comp.addressMatch(apt, street_number, city, street_address, zipcode, search_val.target.value);
						} else {
							this_of_comp.which_event = 'ex_case';
							google.maps.event.trigger(this_of_comp.places, 'place_changed');
							return false;
						}
					} else if (street_address !== '' && zipcode !== '') {
						if (!(which_event === 'geocode' && street_number.indexOf('-') > -1)) {
							this_of_comp.is_zipcode_diff = true;
							this_of_comp.addressMatch(apt, street_number, city, street_address, zipcode, search_val.target.value);
						} else {
							this_of_comp.which_event = 'ex_case';
							google.maps.event.trigger(this_of_comp.places, 'place_changed');
							return false;
						}
					} else if (zipcode !== '') {
						this_of_comp.zipcode = zipcode;
						this_of_comp.sharedService.getTDUs({ 'zipcode': zipcode })
							.then(res => {
								const loader = document.getElementById('is_loader');
								loader.setAttribute('style', 'display:none');
								if (res.status === 'success') {
									if (res.multiple) {
										this_of_comp.router.navigate(['./enroll/zipcode/' + this_of_comp.zipcode]);
									}
									else {
										this_of_comp.router.navigate(['./enroll/zipcode/' + this_of_comp.zipcode + '/tdu/' + res.tdu[0]]);
									}
									setTimeout(function () {
										const len = document.getElementsByTagName('body')[0];
										len.click();
									}, 100);
								} else {
									document.getElementById('is_error_address_yellow').removeAttribute('style');
									document.getElementById('is_error_address_yellow').innerHTML =
										'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
									document.getElementById('home_next').setAttribute('disabled', '');
								}
							});
					} else {
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
						document.getElementById('home_next').setAttribute('disabled', '');
						document.getElementById('is_loader').setAttribute('style', 'display:none');
					}
				} else {
					document.getElementById('is_loader').setAttribute('style', 'display:none');
					document.getElementById('is_error_address_yellow').removeAttribute('style');
					document.getElementById('is_error_address_yellow').innerHTML =
						'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
					document.getElementById('home_next').setAttribute('disabled', '');
					document.getElementById('is_loader').setAttribute('style', 'display:none');
				}
			} else {
				document.getElementById('is_loader').setAttribute('style', 'display:none');
				document.getElementById('is_error_address_yellow').removeAttribute('style');
				document.getElementById('is_error_address_yellow').innerHTML =
					'<p>' + this_of_comp.sharedService.getErrorMessage('address_not_found') + '</p>';
				document.getElementById('home_next').setAttribute('disabled', '');
				document.getElementById('is_loader').setAttribute('style', 'display:none');
			}
		}
	}

	// match address using lat and lng
	addressMatch(apt, street_number, city, street_address, zipcode, search_address) {
		if (zipcode !== '' && street_address !== '') {
			this.sharedService.getServiceAddressesByGoogle({
				'GoogleStreet_Number': street_number,
				'GoogleStreet': street_address, 'GooglePostal_Code': zipcode, 'GoogleCity': city
			})
				.then(res => {
					if (res.result.length > 0) {
						if (res.result.length === 1) {
							const address_obj = res.result[0];
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									this.apt_unit = apartment;
								}
							}
							this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null)
								.map(val => val ? this.filter(val) : this.apartment_list.slice());
							const len = document.getElementsByTagName('body')[0];
							len.click();
							document.getElementById('is_loader').setAttribute('style', 'display:none');
							this.chooseApartUnit('', address_obj);
						} else {
							document.getElementById('is_loader').setAttribute('style', 'display:none');
							this.apt_units = res.result;
							for (let i = 0; i < this.apt_units.length; i++) {
								if (this.apt_units[i].apt_unit != null && this.apt_units[i].apt_unit !== '') {
									let apartment = this.apt_units[i].apt_unit;
									if (apartment.includes(' ')) {
										apartment = apartment.split(' ')[1];
									}
									this.apartment_list.push(apartment);
									if (this.lowerCasePipe.transform(apt) === this.lowerCasePipe.transform(apartment)) {
										this.apt_unit = apartment;
										const len = document.getElementsByTagName('body')[0];
										len.click();
										this.chooseApartUnit(apartment, '');
									}
								}
							}
							if (this.apartment_list.length > 0) {
								this.apartment_obs = this.apartmentFormControl.valueChanges.startWith(null)
									.map(val => val ? this.filter(val) : this.apartment_list.slice());
								document.getElementById('is_apt_exist').removeAttribute('style');
								document.getElementById('is_error_address').setAttribute('style', 'display:none');
								document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
								document.getElementById('apartment').focus();
							} else {
								for (let i = 0; i < this.apt_units.length; i++) {
									if (this.apt_units[i].street_number != null && this.apt_units[i].street_number !== '') {
										if (street_number !== '' &&
											this.lowerCasePipe.transform(street_number) === this.lowerCasePipe.transform(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
										if (street_number === '' && search_address.includes(this.apt_units[i].street_number)) {
											this.chooseApartUnit('', this.apt_units[i]);
										}
									}
								}
							}
						}
					} else {
						document.getElementById('is_loader').setAttribute('style', 'display:none');
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML =
							'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
					}
				});
		} else {
			document.getElementById('is_error_address_yellow').removeAttribute('style');
			document.getElementById('is_error_address_yellow').innerHTML =
				'<p>' + this.sharedService.getErrorMessage('address_not_found') + '</p>';
			document.getElementById('is_loader').setAttribute('style', 'display:none');
		}
	}

	chooseApartUnit(apt_number: string, address_obj: any) {
		if (apt_number !== '') {
			for (let i = 0; i < this.apt_units.length; i++) {
				let apartment = this.apt_units[i].apt_unit;
				if (apartment != null) {
					if (apartment.includes(' ')) {
						apartment = apartment.split(' ')[1];
					}
				}
				if (apartment === apt_number) {
					address_obj = this.apt_units[i];
					this.apt_unit = apartment;
				}
			}
		}
		this.duns = address_obj.duns;
		this.esiid = address_obj.esi_id;
		this.localStorageService.set('address_for_billing', address_obj);
		this.sharedService.validateAddress({ 'ercotId': address_obj.id })
			.then(res => {
				if (res.status === 'success') {
					document.getElementById('is_error_address').setAttribute('style', 'display:none');
					document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
					const len = document.getElementsByTagName('body')[0];
					if (this.is_zipcode_diff) {
						if (this.duns !== '' && this.esiid !== '') {
							let selectedTdu = this.tdus.find((x) => x.duns == this.duns);
							this.router.navigate(['./enroll/esiid/' + this.esiid + '/tdu/' + selectedTdu.tduCode]);
						}
					}
					else {
						len.click();
						const dis = document.getElementById('enroll_now');
						dis.removeAttribute('disabled');
						dis.focus();
						if (address_obj.apt_unit != null && address_obj.apt_unit !== '') {
							document.getElementById('is_apt_exist').removeAttribute('style');
						}
					}
				}
				else {
					if (res.color === 'yellow') {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML = '<p>' + res.message + '</p>';
					} else {
						document.getElementById('is_error_address').removeAttribute('style');
						document.getElementById('is_error_address').innerHTML = '<p>' + res.message + '</p>';
					}
				}
			});
	}

	// autocomplete filter apt or unit
	filter(val: string): string[] {
		return this.apartment_list.filter(option => option.toLowerCase().indexOf(val.toLowerCase()) === 0);
	}
}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'view-efl-dialog1',
	templateUrl: 'view-efl-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class ViewEFL {
	constructor(private activatedRoute: ActivatedRoute, private router: Router, public dialog: MatDialog,
		private sharedService: SharedService, private planService: PlanService, private localStorageService: LocalStorageService) {

	}
	viewDocument(documentName: string) {
		let lang = document.getElementById('which_language').innerHTML;
		// let url = '';
		// if (lang === 'English') {
		//     lang = 'www';
		// }else {
		//     lang = 'es';
		// }

		this.planService.getDocument(documentName, lang)
			.then(res => {
				if (res != undefined && res.status == 'success') {
					window.open(res.result[0].document_url, '_blank');
				}
			});

		// this.planService.getDocumentUrls()
		//   .then(res=>{
		//     let url = '';
		//     var urlObj;
		//     if (lang === 'English') {
		//       urlObj = res.en;
		//     }else {
		//       urlObj = res.es;
		//     }

		//     if (documentName === 'EFL') {
		//       url = urlObj.efl;
		//     }else if (documentName === 'PDS') {
		//       url = urlObj.pds;
		//     }else if (documentName === 'TOS') {
		//       url = urlObj.tos;
		//     }else if (documentName === 'YRAC') {
		//       url = urlObj.yrac;
		//     }
		//     window.open(url, '_blank');
		//   });

		// this.planService.getDocument(documentName, lang);
		// if (documentName === 'EFL') {
		//   url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2017/10/Pogo_Energy_EFL_20171001.pdf';
		// }else if (documentName === 'PDS') {
		//   url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2017/10/Pogo_Energy_PDS_20171001.pdf';
		// }else if (documentName === 'TOS') {
		//   url = 'https://' + lang + '.pogoenergy.com/wp-content/uploads/2017/10/Pogo_Energy_TOS_20171001.pdf';
		// }else if (documentName === 'YRAC') {
		//   url = 'https://' + lang   + '.pogoenergy.com/wp-content/uploads/2017/10/Pogo_Energy_YRAC_20171001.pdf';
		// }
		// window.open(url, '_blank');
	}
}

export interface DetailedView {
	month: string;
	charges: string;
	credits: string;
	balance: string;
}

export class DetailedView extends DataSource<any> {
	public data: DetailedView[];
	constructor(private elementData: DetailedView[]) {
		super();
		this.data = this.elementData;
	}
	connect(): Observable<DetailedView[]> {
		return Observable.of(this.data);;
	}
	disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/plan/plan-detail/plan-detail.component.ts